import React, { Component } from 'react';
import PropTypes from 'prop-types';
import createMarkup from '@medscape-promo/medscapetv/utils/create-markup';

class CommentsContent extends Component {
    constructor(props){
        super(props);
        this.contentRef = React.createRef();
        require('./comments-content.scss');
    }
    componentDidUpdate(prevProps, prevState) {
        if(prevProps.content != this.props.content && this.props.content.trim() != ""){
            this.props.onRendered(this.contentRef.current);
        }
    }
    componentDidMount(){
        if(this.props.content != null || this.props.content!=""){
            this.props.onRendered(this.contentRef.current);
        }
    }
    render(){
        if(this.props.content != null){
            return(
                <div className="content-wrapper">
                    <div ref={this.contentRef} id="commentsContainer" dangerouslySetInnerHTML={createMarkup(this.props.content) }></div>
                </div>
            );
        }
        else{
            return null;
        }
    }
    static get propTypes() {
        return {
            content: PropTypes.string,
            onRendered: PropTypes.func
        }
    }
}


export default CommentsContent